import { DotsHorizontal } from '@aktiia/design-system';
import { useState } from 'react';
import { Popover } from 'react-tiny-popover';

import { DeviceMenuPopover } from './components';
import { IDeviceMenuProps } from './types';

export const DeviceMenu = ({ device }: IDeviceMenuProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const handleOnClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  return (
    <div className="flex items-center justify-end cursor-pointer">
      <Popover
        align="end"
        reposition={false}
        padding={8}
        isOpen={isPopoverOpen}
        onClickOutside={handleClose}
        positions={['bottom']}
        content={<DeviceMenuPopover device={device} />}
      >
        <button onClick={handleOnClick}>
          <DotsHorizontal />
        </button>
      </Popover>
    </div>
  );
};
